module.exports = __webpack_public_path__ + "img/wf.286c9637.svg";